import { TableBody, TableCell, TableRow } from "@mui/material";
import classNames from "classnames";
import type { StaticKeyResponseType } from "../../../../../services/api/instances/staticTokenApi/types";
import { useAppSelector } from "../../../../../services/redux/hooks/use-selector";
import { AppLoading } from "../../../../../shared/components/AppLoading";
import { transformToken } from "../../helpers";
import { selectLoading } from "../../redux/selector";
import { StaticTokenActionsCell } from "../TabelCells/StaticTokenActionsCell";
import { StaticTokenValidationCell } from "../TabelCells/StaticTokenValidationCell";
import { TokenPreview } from "../TabelCells/TokenPreview";
import styles from "./styles.module.css";

interface Props {
  tokens: StaticKeyResponseType[];
  token: string;
  onCreate: () => void;
  onDelete: (id: number) => void;
  onChange: (date: Date, id: number) => void;
  isPreview: boolean;
}

export const StaticTokenTableBody = (props: Props) => {
  const isLoading = useAppSelector(selectLoading);
  return (
    <TableBody>
      {isLoading ? (
        <TableRow className={styles["table-body-row"]}>
          <TableCell colSpan={3}>
            <AppLoading />
          </TableCell>
        </TableRow>
      ) : Array.isArray(props.tokens) && props.tokens?.length > 0 ? (
        props.tokens?.map((token, index) => {
          if (!token || token.id == null || token.static_key == null) {
            console.warn("Skipping invalid token at index", index, token);
            return null;
          }
          return (
            <TableRow
              key={token?.id}
              className={classNames(
                styles["table-body-row"],
                props.isPreview && styles["opacity"]
              )}
            >
              <TableCell className={styles["token-cell"]}>
                {transformToken(token.static_key)}
              </TableCell>
              <StaticTokenValidationCell
                validDate={token.valid_till}
                onChange={(date) => props.onChange(date, token.id)}
              />
              <StaticTokenActionsCell
                copyToken={token.static_key}
                onDelete={() => props.onDelete(token.id)}
              />
            </TableRow>
          );
        })
      ) : !props?.isPreview ? (
        <TableRow className={styles["table-body-row"]}>
          <TableCell colSpan={3} className={styles["no-tokens-label"]}>
            Нет токенов
          </TableCell>
        </TableRow>
      ) : null}

      {props.isPreview && (
        <TokenPreview token={props.token} onCreate={props.onCreate} />
      )}
    </TableBody>
  );
};
